import React, { useState } from "react";
import {
	List,
	Datagrid,
	TextField,
	BooleanField,
	TextInput,
	SelectInput,
	BooleanInput,
	Filter,
	SelectField,
	Button,
	showNotification
} from "react-admin";
import { connect } from 'react-redux';
import { refreshView } from 'ra-core';
import { 
	Dialog, 
	DialogTitle, 
	DialogContent, 
	DialogActions, 
	DialogContentText,
	CardActions,
	Button as MuiButton
} from '@material-ui/core';
import { generateAmbassadorDiscountCode } from '../dataProvider';

// 创建筛选组件
const DiscountCodeFilter = ({ permissions, ...props }) => (
	<Filter {...props}>
		<TextInput source="code" label="Code" alwaysOn />
		{permissions !== 'ambassador' && (
			<SelectInput 
				source="code_type" 
				label="Code Type" 
				choices={[
					{ id: 'fixed', name: 'Fixed' },
					{ id: 'percentage', name: 'Percentage' },
                    {id: 'free_under_amount', name: 'Free Under Amount' }
				]}
				alwaysOn
			/>
		)}
		{permissions !== 'ambassador' && (
			<BooleanInput source="is_used" label="Is Used" alwaysOn />
		)}
	</Filter>
);

// 创建一个自定义的布尔字段组件
const CustomBooleanField = ({ record = {}, source }) => (
    <BooleanField record={{ ...record, [source]: record[source] || false }} source={source} />
);

// 创建一个自定义的使用次数字段组件
const UsageCountField = ({ record = {}, source }) => {
    const value = record[source] !== undefined && record[source] !== null ? record[source] : 0;
    return <span>{value}</span>;
};

// 创建自定义的Actions组件，包含Generate New Discount Code按钮
const DiscountCodeListActions = ({ permissions, showNotification, refresh, ...props }) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await generateAmbassadorDiscountCode();
            showNotification('Discount code generated successfully!', 'info');
            refresh();
            setOpen(false);
        } catch (error) {
            // 解析错误信息
            let errorMessage = 'Failed to generate discount code. Please try again.';
            if (error && error.body && error.body.message) {
                // 如果服务器返回了具体的错误信息
                errorMessage = error.body.message;
            } else if (error && error.message) {
                // 如果有其他错误信息
                errorMessage = error.message;
            }
            
            showNotification(errorMessage, 'warning');
        } finally {
            setLoading(false);
        }
    };

    if (permissions !== 'ambassador') {
        return null;
    }

    return (
        <>
            <CardActions>
                <Button 
                    label="Generate New Discount Code" 
                    onClick={handleClickOpen}
                    variant="contained"
                    color="primary"
                />
            </CardActions>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Generate New Discount Code"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to create a new discount code?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MuiButton onClick={handleClose} color="primary">
                        Cancel
                    </MuiButton>
                    <MuiButton 
                        onClick={handleConfirm} 
                        color="primary" 
                        autoFocus
                        disabled={loading}
                    >
                        {loading ? 'Generating...' : 'Confirm'}
                    </MuiButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

const DiscountCodeList = ({ permissions, showNotification, refresh, ...props }) => (
	<List 
		{...props}  
		bulkActionButtons={false}  
		title={'Discount Codes'}
		filters={<DiscountCodeFilter permissions={permissions} />}
		exporter={permissions == 'system_admin'}
		hasCreate={permissions == 'system_admin'}
	>
		<Datagrid>
			<TextField source="code" label="Code" />
            <SelectField 
                source="type" 
                label="Code Type"
                choices={[
                    { id: 'fixed', name: 'Fixed' },
                    { id: 'percentage', name: 'Percentage' },
                    { id: 'free_under_amount', name: 'Free Under Amount' }
                ]}
            />
			<TextField source="value" label="Value" />
			<TextField source="expires_at" label="Expires At" />
			<CustomBooleanField source="is_used" label="Is Used" />
			<UsageCountField source="usage_count" label="Usage Count" />
            <UsageCountField source="max_usage_count" label="Max Usage Count" />
            <TextField source="source" label="Source" />
            <TextField source="last_used_at" label="Last Used Time" />
		</Datagrid>
	</List>
);

// 连接Redux以获取showNotification和refreshView功能
const mapDispatchToProps = {
    showNotification,
    refresh: refreshView
};

export default connect(null, mapDispatchToProps)(DiscountCodeList);
